import { el } from "@dhx/ts-common/dom";
import { ICol, IRendererConfig, GridEvents, IRow, IEditor } from "../../types";

export class CheckboxEditor implements IEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _cell: { row: IRow, col: ICol };
	protected _config: IRendererConfig;
	protected _checkbox: HTMLInputElement;
	protected _input: HTMLInputElement;
	protected _checked: boolean;

	constructor(row: IRow, col: ICol, config: IRendererConfig) {
		this._config = config;
		this._cell = { row, col };
		this._initHandlers();
	}

	endEdit() {
		const value: any = this._checked;
		if (this._config.events.fire(GridEvents.beforeEditEnd, [value, this._cell.row, this._cell.col])) {
			this._handlers = {};
			this._config.events.fire(GridEvents.afterEditEnd, [value, this._cell.row, this._cell.col]);
		}
	}

	toHTML() {
		if (this._checked === undefined) {
			this._checked = this._cell.row[this._cell.col.id];
		}
		if (this._input) {
			return;
		}
		return el("label.dhx_checkbox.dhx_cell-editor__checkbox", [
			el("input.dhx_checkbox__input", {
				type: "checkbox",
				_hooks: {
					didInsert: this._handlers.didInsert
				},
				_key: "cell_editor",
				dhx_id: "cell_editor",
				checked: this._checked,
				style: {
					userSelect: "none"
				}
			}),
			el("span.dhx_checkbox__visual-input")
		]);
	}

	protected _initHandlers() {
		this._handlers = {
			onChange: (e: Event) => {
				this._checked = (e.target as HTMLInputElement).checked;
				this.endEdit();
			},
			didInsert: (node: any) => {
				this._checkbox = node.el.parentNode.lastChild;
				this._input = node.el.parentNode.firstChild;
				this._input.addEventListener("change", this._handlers.onChange);
			}
		};
	}
}